// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ui.dimmer[data-v-3bd8d6c0] {\n    background-color: rgba(0,0,0,.1) !important;\n}\n.delete-alert-modal-header[data-v-3bd8d6c0] {\n    text-align: center !important;\n    font-size: medium !important;\n}\n", ""]);
// Exports
module.exports = exports;
